module.exports = __webpack_public_path__ + "assets/img/woman.3027456a.png";